import { CashRegisterStoryType } from 'services/enums/CashRegister.enum';

export const _cashRegisterStoryTypes = [
  CashRegisterStoryType.IN,
  CashRegisterStoryType.OUT,
];
